import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from '@/routes/utils';

const CountyMapPage = lazyWithRetry(() => import('@/pages/counties/CountyMapPage'));
const PolandMapPage = lazyWithRetry(() => import('@/pages/counties/PolandMapPage'));

export const countiesRoutes = (
  <>
    <Route path="/powiaty/:slug" element={<CountyMapPage />} />
    <Route path="/powiaty/:slug/mapa" element={<CountyMapPage />} />
    <Route path="/polska" element={<PolandMapPage />} />
  </>
);
